import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      display: 'inline',
    },
    root: {
      backgroundColor: COLORS.primary.silver,
      borderRadius: theme.shape.borderRadiusSmall,
      padding: theme.spacing(0, 0.25),
      color: COLORS.primary.active,
    },
  }),
  { name: 'PromptImageNode' }
);
